import { render, staticRenderFns } from "./WaiterJudgeTemplateInputItem.vue?vue&type=template&id=e98ef89e&scoped=true&lang=pug"
import script from "./WaiterJudgeTemplateInputItem.vue?vue&type=script&lang=ts"
export * from "./WaiterJudgeTemplateInputItem.vue?vue&type=script&lang=ts"
import style0 from "./WaiterJudgeTemplateInputItem.vue?vue&type=style&index=0&id=e98ef89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98ef89e",
  null
  
)

export default component.exports